import AnalyticItemFilterContainer from 'containers/employee-analytics/analytic-item/AnalyticItemFilterContainer'
import Spinner from 'components/commons/spinner'

export const Card = ({ title, children, isLoading, filterTitle, initFilter, initOptions, onSubmitFilter }) => {
    return (
        <div
            className='bg-white border border-neutral-30 rounded-lg shadow-sm p-3'
            onMouseDown={(e) => e.preventDefault()}
        >
            <div className='flex items-center justify-between mb-2'>
                <h3 className='font-semibold text-lg'>{title}</h3>
                {filterTitle && (
                    <AnalyticItemFilterContainer
                        title={filterTitle}
                        initFilter={initFilter}
                        initOptions={initOptions}
                        onSubmit={onSubmitFilter}
                    />
                )}
            </div>
            {isLoading ? (
                <div className={'w-full h-full flex justify-center items-center pb-16'}>
                    <Spinner className={'w-5 h-5 border-primary-50'} />
                </div>
            ) : (
                children
            )}
        </div>
    )
}
